// removed by extract-text-webpack-plugin
module.exports = {"dimmer-container":"ServicesPanelPlaceholder__dimmer-container___zuzs8","placeholder":"ServicesPanelPlaceholder__placeholder___3zGWP"};